<ng-container *ngIf="controlType === 'filter'">
	<p class="compact-select-label font-size-085 mb-0">
		{{ label }}
		<a href="javascript:void(0)" class="ml-1 dark-blue-link semibold-text" (click)="showLookupEnterprise()">
			{{ enterprise?.name ?? nullEnterpriseText }}
		</a>
		<a *ngIf="enterprise" href="javascript:void(0)" (click)="clearEnterprise()">
			<fa-icon class="text-danger', 'ml-2']" [icon]="['fas', 'times']"></fa-icon>
		</a>
	</p>
</ng-container>

<ng-container *ngIf="controlType === 'form'">
	<label class="title" [class.required]="isRequired" [for]="inputId">{{ label }}</label>
	<div class="input-group">
		<input type="text" class="form-control" [id]="inputId" [value]="enterprise?.name ?? nullEnterpriseText" readonly />
		<div class="input-group-append">
			<button type="button" class="btn btn-default" (click)="clearEnterprise()">
				<fa-icon [icon]="['fas', 'times']"></fa-icon>
			</button>
			<button type="button" class="btn btn-default" (click)="showLookupEnterprise()">
				<fa-icon [icon]="['fas', 'search']"></fa-icon>
			</button>
		</div>
	</div>
</ng-container>
